import { useState } from 'react'

import { Box, styled } from '@mui/material'
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium'

import { SelectOption } from '../../DynamicForm/models/DynamicFieldData'
import { SelectDropdown } from '../../SelectDropdown/SelectDropdown'

type SelectEditCellProps = GridRenderEditCellParams & {
  required?: boolean
  placeholder?: string
  options: SelectOption[] 
}

export const SelectEditCell: React.FC<SelectEditCellProps> = ({
  id,
  field,
  value,
  placeholder,
  options,
}) => {
  const apiRef = useGridApiContext()
  const [selectedOption, setSelectedOption] = useState<SelectOption | null>(options.find(option => option.value === value) || null)

  const handleValueChange = (selOpt: SelectOption) => {
    setSelectedOption(selOpt)

    // Grab the value from the option before setting it
    apiRef.current.setEditCellValue({
      id,
      field,
      value: selOpt?.value || null,
      debounceMs: 200,
    })
  }

  return (
    <StyledSelectEditCell>
      <StyledSelectDropdown
        value={selectedOption}
        options={options}
        placeholder={placeholder}
        disablePortal={false}
        onChange={(_, val) => {
          handleValueChange(val as SelectOption)
        }}
        getOptionLabel={(option) => {
          return (option as SelectOption).label
        }}
        isOptionEqualToValue={(option, selOpt) => {
          return (option as SelectOption).value === (selOpt as SelectOption).value
        }}
      />
    </StyledSelectEditCell>
  )
}

const StyledSelectEditCell = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .MuiInputBase-root {
    &::before, &::after {
      display: none !important;
    }
  }

  .MuiInputBase-input {
    padding: 0;
    height: auto;
  }
`

const StyledSelectDropdown = styled(SelectDropdown)`
  .MuiInputAdornment-positionEnd {
    margin-left: 0;
  }

  .MuiIconButton-root {
    padding: 0;
    margin: 0;
    background-color: transparent;
  }
`